import React from 'react'
import PropTypes from 'prop-types'

import { Label } from 'semantic-ui-react'

import * as styles from './styles'

const GroupPermissionHeaderTitle = ({ selected, settings, title }) => {
  return (
    <span>
      {title}
      <Label style={styles.label}>
        {selected}/{settings}
      </Label>
    </span>
  )
}

GroupPermissionHeaderTitle.propTypes = {
  selected: PropTypes.number.isRequired,
  settings: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
}

export default GroupPermissionHeaderTitle
